{
  "pages": {
    "billing": {
      "title": "Billing"
    }
  },
  "components": {
    "summaryTable": {
      "title": "Summary",
      "rowName": "SIB-Waste",
      "sibRowName": "SIB",
      "columns": {
        "name": "Summary",
        "thirtyDays": "0-30 days",
        "sixtyDays": "31-60 days",
        "ninetyDays": "61-90 days",
        "overNinetyDays": "90+ days",
        "total": "Total"
      },
      "noData": {
        "title": "No data found",
        "description": "No data has been added yet"
      }
    },
    "invoiceDetailsTable": {
      "title": "Invoice Details",
      "tabs": {
        "wasteInvoices": "Waste invoices",
        "invoices": "Invoices"
      },
      "invoicesBillingDataUnavailable": "Other invoices billing data is temporarily unavailable. Please contact support or try again later",
      "downloadErrorDescription": "Unable to download invoice {{invoiceId}}. The file may be temporarily unavailable or there was a network issue. Please try again in a moment.",
      "unpaidInvoices_one": "You have <strong>{{count}}</strong> unpaid invoice",
      "unpaidInvoices_other": "You have <strong>{{count}}</strong> unpaid invoices",
      "columns": {
        "invoiceId": "Invoice ID",
        "invoiceDate": "Invoice Date",
        "dueDate": "Due Date",
        "amount": "Amount",
        "balance": "Balance",
        "earnedCredits": "Earned Credits",
        "status": "Status",
        "locationId": "Location ID",
        "locationName": "Location Name",
        "vendorName": "Vendor Name",
        "accountNumber": "Account #",
        "attachedFiles": "Attached files"
      },
      "actions": {
        "select": {
          "fileUnavailable": "Invoice is temporarily unavailable"
        },
        "export": {
          "tooltip": "Download invoices",
          "tooltipNoSelection": "No invoices selected",
          "tooltipNoData": "No invoices to export",
          "tooltipAll": "Export all invoices",
          "errorMessage": "An error occurred while exporting the invoices."
        }
      },
      "noData": {
        "title": "No invoices found",
        "description": "No invoices have been added yet"
      }
    },
    "attachedFiles": {
      "downloadFile": "Download file"
    },
    "pdfModal": {
      "title": "Invoice no.{{number}}",
      "iframeTitle": "Invoice PDF",
      "fallbackTitle": "Invoice",
      "loading": "Loading invoice...",
      "error": {
        "title": "Unable to load invoice",
        "message": "There was an error loading the invoice. Please try again later."
      }
    }
  },
  "notifications": {
    "billingError": {
      "title": "Internal Server Error",
      "description": "An error occurred while loading billing data. Please try again later or contact support if the problem persists."
    }
  },
  "enums": {
    "invoicePaymentStatus": {
      "paid": "Paid in full",
      "partiallyPaid": "Partially paid",
      "pastDue": "Past due",
      "unpaid": "Unpaid"
    }
  }
}
